export const COMMON_CURRENCY_LOCALIZATION_SCOPE = 'common-currency';
export const FALLBACK_CURRENCY = 'USD';
